import { SimpleGrid } from '@chakra-ui/react';
import { AnalyticsEventProps } from '../common/libs/googleAnalytics';
import { VideoArticle } from '../server/libs/videoArticles';
import VideoArticleSummary from './VideoArticleSummary';

export default function VideoArticlesGrid({
  articleId,
  videoArticles,
  isMobile = true,
  gaEventLabel,
  additionalGaEvent,
  maxColumns = 3,
  onVideoArticleClick,
}: {
  articleId: string;
  videoArticles: VideoArticle[];
  isMobile?: boolean;
  gaEventLabel?: string;
  additionalGaEvent?: AnalyticsEventProps;
  maxColumns?: 2 | 3; // デフォルトで最大3カラムとして、2カラムを選べるようにしている
  onVideoArticleClick?: (props: { videoId: string; articleId: string }) => void;
}) {
  const columns = [1, 2, maxColumns];

  return (
    <SimpleGrid columns={columns} spacing={4} w="full">
      {videoArticles.map((videoArticle) => (
        <VideoArticleSummary
          key={videoArticle.videoId}
          {...videoArticle}
          articleId={articleId}
          gaEventLabel={gaEventLabel}
          additionalGaEvent={
            additionalGaEvent && {
              ...additionalGaEvent,
              label: `${videoArticle.videoId}${additionalGaEvent.label || ''}`,
            }
          }
          isMobile={isMobile}
          onClick={onVideoArticleClick}
        />
      ))}
    </SimpleGrid>
  );
}
